import type { Lens } from '@dhmk/zustand-lens';

export type FlagValue = string | string[] | Record<string, number>;
export type FlagType = Record<string, FlagValue> | undefined;

export type GlobalState = {
  featureFlags: FlagType | undefined;
  hasHydrated: boolean;
};

export type GlobalActions = {
  setFeatureFlags: (flags: FlagType) => void;
  setHasHydrated: (hasHydrated: boolean) => void;
};

export type GlobalSlice = GlobalState & { actions: GlobalActions };

const sliceName = 'global';
export const createGlobalSlice: Lens<GlobalSlice> = (set) => {
  return {
    featureFlags: undefined,
    userSession: null,
    hasHydrated: false,

    actions: {
      setFeatureFlags: (featureFlags) =>
        set({ featureFlags }, undefined, `${sliceName}/setFeatureFlags`),
      setHasHydrated: (hasHydrated: boolean) =>
        set({ hasHydrated }, undefined, `${sliceName}/hasHydrated`),
    },
  };
};
